const findBankByCode = (banks = {}, code) => Object.values(banks).find(bank => bank.code === code);

export default findBankByCode;